module.exports = __webpack_public_path__ + "static_pc/img/af4.10297839.png";